import { CheckCircle2, Heart, Users, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-32 bg-slate-50 relative overflow-hidden" data-testid="about-section">
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50 -translate-y-1/3 translate-x-1/3" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full bg-blue-600 rounded-2xl" />
              <img
                src="/about-mechanics.jpg"
                alt="Équipe Sphère Auto - mécaniciens au travail"
                className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/5]"
              />
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-2xl p-5 border border-slate-100" data-testid="about-badge">
                <div className="text-3xl font-heading font-extrabold text-blue-600">2026</div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">Année d&apos;ouverture</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="text-sm font-semibold uppercase tracking-widest text-blue-600 mb-4">À propos</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-slate-900 tracking-tight leading-tight">
              Un nouveau centre auto, <br />
              une équipe à votre écoute.
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Nouveau centre auto installé depuis début 2026 à Loos-en-Gohelle, <span className="font-semibold text-slate-900">Sphère Auto</span> regroupe tous les services dont votre véhicule a besoin. Notre engagement : la qualité, la transparence et le sourire.
            </p>

            <div className="mt-8 space-y-4">
              {[
                { icon: ShieldCheck, title: "Réactif", desc: "Diagnostic rapide, devis sous 24/48h, intervention sans délai inutile." },
                { icon: CheckCircle2, title: "Consciencieux", desc: "Travail soigné, pièces de qualité, contrôle rigoureux à chaque étape." },
                { icon: Heart, title: "À l'écoute", desc: "On vous explique tout, sans jargon. Vous décidez en toute confiance." },
              ].map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div key={idx} className="flex gap-4 items-start" data-testid={`about-value-${idx}`}>
                    <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                      <div className="font-heading font-bold text-lg text-slate-900">{item.title}</div>
                      <div className="text-sm text-slate-600 mt-1">{item.desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
